import { render, staticRenderFns } from "./Hoteles.vue?vue&type=template&id=61e35b17&scoped=true&"
import script from "./Hoteles.vue?vue&type=script&lang=js&"
export * from "./Hoteles.vue?vue&type=script&lang=js&"
import style0 from "./Hoteles.vue?vue&type=style&index=0&id=61e35b17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e35b17",
  null
  
)

export default component.exports